import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/orderRemainingHoursReport-actions';
import { OrderRemainingHoursReportActions } from '../constants';
import { IOrderRemainingHoursReport } from 'src/types/orderRemainingHoursReport';

export interface OrderRemainingHoursReportState {
    inProgress: boolean;
    authCode: string;
    error: string;
    totals: any;
    data: Paginated<IOrderRemainingHoursReport>;
    current: IOrderRemainingHoursReport | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    totals: {},
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function orderRemainingHoursReports(
    state: OrderRemainingHoursReportState = initialState,
    action: Actions | any,
): OrderRemainingHoursReportState {
    switch (action.type) {
        case requestType(OrderRemainingHoursReportActions.PERSIST_ORDER_REMAINING_HOURS_REPORT):
            return { ...state, error: '', inProgress: true };
        case successType(OrderRemainingHoursReportActions.PERSIST_ORDER_REMAINING_HOURS_REPORT):
            return { ...state, inProgress: false };
        case failureType(OrderRemainingHoursReportActions.PERSIST_ORDER_REMAINING_HOURS_REPORT):
            return { ...state, error: action.error, inProgress: false };

        case requestType(OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORTS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORTS):
            return {
                ...state,
                data: {
                    ...action.payload,
                    list: Object.keys(state.totals).length
                        ? [state.totals, ...action.payload.list]
                        : action.payload.list,
                    inProgress: false,
                },
                inProgress: false,
            };
        case failureType(OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORTS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case successType(OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORTS_TOTALS):
            if (action.total) {
                return {
                    ...state,
                    totals: action.payload,
                    data: {
                        ...state.data,
                        ...action.payload,
                        list: Object.keys(action.payload).length
                            ? [action.payload, ...state.data?.list]
                            : state.data?.list,
                        inProgress: false,
                    },
                    inProgress: false,
                };
            }
            return state;

        case failureType(OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORTS_TOTALS):
            return { ...state, totals: {}, error: action.error, inProgress: false };
        case requestType(OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORTS_TOTALS):
            return { ...state, inProgress: true, totals: {}, error: '' };

        case requestType(OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORT):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORT):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORT):
            return { ...state, inProgress: false, error: action.error };
        case requestType(OrderRemainingHoursReportActions.DELETE_ORDER_REMAINING_HOURS_REPORT):
            return { ...state, error: '', inProgress: true };
        case successType(OrderRemainingHoursReportActions.DELETE_ORDER_REMAINING_HOURS_REPORT):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IOrderRemainingHoursReport) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(OrderRemainingHoursReportActions.DELETE_ORDER_REMAINING_HOURS_REPORT):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
